import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { appPaths } from "../../../shared/routing/appPaths";
import StatusMessage from "../../../ui/feedback/StatusMessage";
import { shortReference } from "../../../shared/references/shortReferences";
import type { CorpusImportOutcome } from "./corpusImport";

/** What an import changed: the new corpus version, and how many documents it touched. */
export default function ImportResultSummary({ outcome }: { outcome: CorpusImportOutcome }) {
  const { t } = useTranslation();
  const { result } = outcome;
  const version = shortReference("gitObject", result.version.commit);

  return (
    <StatusMessage tone="success" title={t("sources.import.result.title")}>
      <p>
        {result.createdVersion
          ? t("sources.import.result.documentsVersion", { version })
          : t("sources.import.result.unchanged", { version })}
      </p>
      {result.segmentationChanged ? <p>{t("sources.import.result.segmentationChanged")}</p> : null}
      <p className="mt-2">
        {t("sources.import.result.counts", {
          added: result.addedCount,
          modified: result.modifiedCount,
          removed: result.removedCount,
          unchanged: result.unchangedCount,
        })}
      </p>
      <Link to={appPaths.sources()} className="app-link mt-2 inline-block underline">
        {t("sources.import.result.open")}
      </Link>
    </StatusMessage>
  );
}
